import { FaArrowLeftLong, FaArrowRightLong, FaRepeat } from "react-icons/fa6";
import StaticLayout from "../../layout/StaticPageLayout2";
import { BsBag, BsClockHistory, BsWifi } from "react-icons/bs";
import { useEffect, useState } from "react";
import { Button } from "../../layout/component/Button";
import { FaCoffee } from "react-icons/fa";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useNavigate } from "react-router-dom";
import { routeObj } from "../../constants/routes";
import { useAppDispatch, useAppSelector } from "../../store";
import { SelectUpdate } from "../../store/slice/update";
import { searchFlight } from "../../store/service/flight";
import { SelectFlight } from "../../store/slice/flight";
import { findLocationFromIATA } from "../../utils/data";
import {
  convertMinutesToHoursAndMinutes,
  dateFormatter,
  dateFormatterWithNoYear,
  dateTime,
  numberFormatter,
} from "../../utils/functions";
import { Flights } from "../../store/slice/flight/initial";
import EmptyList from "../../components/EmptyList";
import useCountdown from "../../components/useCountdown";

export default function Flight() {
  const [open, setOpen] = useState(false);
  const [filter, setFilter] = useState(false);
  const [listindex, setLinkIndex] = useState("");
  const router = useNavigate();
  const { query, others } = useAppSelector(SelectUpdate);
  const { data, loading } = useAppSelector(SelectFlight);
  const dispatch = useAppDispatch();
  const [allFlight, setAllFlight] = useState<Flights[]>([]);
  const [oneStop, setOneStop] = useState(false);
  const [twoStop, setTwoStop] = useState(false);
  const [priceRange, setPriceRange] = useState<number>(0);
  const [maxPrice, setMaxPrice] = useState<number>(0);

  const fetchData = async () => {
    try {
      await dispatch(
        searchFlight({
          ...query,
          adults: others?.adults,
          children: others?.children,
          type: others?.trip === "ROUND_TRIP" ? 1 : 2,
        })
      ).unwrap();
    } catch (error) {}
  };

  useEffect(() => {
    if (data?.length !== 0) {
      if (others?.trip === "ROUND_TRIP") {
        const roundTrip = data?.filter((other) => other.type === "Round trip");
        setMaxPrice(Math.max(...allFlight.map((item) => item.price)));
        setAllFlight(roundTrip);
      }

      if (others?.trip !== "ROUND_TRIP") {
        const roundTrip = data?.filter((other) => other.type !== "Round trip");
        setMaxPrice(Math.max(...allFlight.map((item) => item.price)));
        setAllFlight(roundTrip);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  // console.log(data);

  const { minutes, seconds, hasEnded, resetCountdown } = useCountdown(0);

  useEffect(() => {
    if (query) {
      fetchData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const handleSliderChange = (event: any, newValue: any) => {
    setPriceRange(newValue);
  };

  // useEffect(() => {
  //   if (priceRange) {
  //     const prices = allFlight?.filter(
  //       (other) => Number(other?.price) > Number(priceRange)
  //     );
  //     if (prices.length === 0) {
  //       return;
  //     }
  //     setAllFlight(prices);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [priceRange])

  useEffect(() => {
    if (!loading) {
      const date = new Date();
      const newDate = date.setSeconds(date.getSeconds() + 300);
      resetCountdown(newDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  useEffect(() => {
    if (hasEnded) {
      router(routeObj.landing);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasEnded]);

  return (
    <StaticLayout>
      <div className=" min-h-[250px] md:min-h-[300px] py-10 bg-main ">
        <div className="justify-center gap-8 text-white w-[95%] border-[1px] p-3 mx-auto flex  md:hidden  items-center ">
          <FaArrowLeftLong onClick={() => router(-1)} />
          <div className=" ">
            <div className="flex items-center text-sm ">
              {findLocationFromIATA(query.departure_id)} -{" "}
              {findLocationFromIATA(query.arrival_id)}{" "}
            </div>
            <div className="flex items-center gap-2 text-[12px] ">
              <p className="">
                {dateFormatterWithNoYear(query.outbound_date)} -{" "}
                {dateFormatterWithNoYear(query.return_date)}{" "}
              </p>
              |<p className="">{others.adults} Adults </p>|
              <p className=""> {others?.children} Children </p>
            </div>
          </div>
        </div>
        <div className=" hidden w-[80%] mx-auto md:flex gap-2 items-center   text-white ">
          <div className=" w-[15%] min-h-[60px] bg-secondary/80 p-2 shadow-xl  ">
            <p className="uppercase">Trip Type</p>
            <p className=" font-semibold text-[17px] ">
              {others?.trip === "ROUND_TRIP" ? "Round Trip" : "One Way"}
            </p>
          </div>
          <div className=" w-[15%] min-h-[60px] bg-secondary/80 p-2 shadow-xl  ">
            <p className="uppercase">From</p>
            <p className=" font-semibold text-[17px] ">
              {findLocationFromIATA(query.departure_id)}
            </p>
          </div>
          <div className=" rounded-full p-2 px-3 bg-white ">
            <FaRepeat className=" text-main " />
          </div>
          <div className=" w-[15%] min-h-[60px] bg-secondary/80 p-2 shadow-xl  ">
            <p className="uppercase">To</p>
            <p className=" font-semibold text-[17px] ">
              {findLocationFromIATA(query.arrival_id)}
            </p>
          </div>
          <div className=" w-[15%] min-h-[60px] bg-secondary/80 p-2 shadow-xl  ">
            <p className="uppercase">Depature</p>
            <p className=" font-semibold text-[17px] ">
              {dateFormatter(query.outbound_date)}
            </p>
          </div>
          {others?.trip === "ROUND_TRIP" && (
            <div className=" w-[15%] min-h-[60px] bg-secondary/80 p-2 shadow-xl  ">
              <p className="uppercase">Return</p>
              <p className=" font-semibold text-[17px] ">
                {dateFormatter(query.return_date)}
              </p>
            </div>
          )}
          <div className=" w-[20%] min-h-[60px] bg-secondary/80 p-2 shadow-xl  ">
            <p className="uppercase">Passenger</p>
            <div className=" font-semibold flex justify-between w-full text-[14px] ">
              <p className="">Children: {others?.children}.</p>{" "}
              <p className=""> Adults: {others?.adults}</p>
            </div>
          </div>
        </div>
      </div>

      {
        <div className=" my-10 w-[95%] md:w-[85%] mx-auto flex flex-col md:flex-row gap-10 ">
          {!loading && allFlight?.length !== 0 && (
            <>
              <div className=" w-full md:w-[25%]">
                {!loading && (
                  <div className=" w-full shadow-2xl rounded-lg flex flex-col gap-5  bg-white  border-[1px] p-5 ">
                    <div className="flex cursor-pointer  items-center gap-2 w-full ">
                      <FaArrowLeftLong
                        onClick={() => router(routeObj.landing)}
                      />{" "}
                      Back To Search
                    </div>
                    <div
                      onClick={() => {
                        setFilter(!filter);
                      }}
                      className=" bg-form w-full flex items-center justify-between rounded-md p-3 "
                    >
                      Filters
                      {!filter ? <IoIosArrowDown /> : <IoIosArrowUp />}
                    </div>
                    {filter && (
                      <div className="">
                        {/* <input
                          type="range"
                          min={0}
                          max={maxPrice}
                          value={priceRange}
                          onChange={(e) => {
                            handleSliderChange(e, e.target.value);
                          }}
                          className="w-full h-2  rounded-lg mb-3 cursor-pointer"
                        /> */}
                        <div className="flex items-center gap-2 ">
                          <input
                            onChange={(e) => {
                              setTwoStop(false);
                              setOneStop(!oneStop);
                              if (!oneStop) {
                                const roundTrip = data?.filter(
                                  (other) => other.flights.length === 1
                                );
                                setAllFlight(roundTrip);
                              }
                            }}
                            checked={oneStop}
                            type="checkbox"
                            name=""
                            id=""
                          />{" "}
                          1 Stop
                        </div>
                        <div className="flex items-center gap-2 ">
                          <input
                            onChange={(e) => {
                              setOneStop(false);
                              setTwoStop(!twoStop);
                              if (!twoStop) {
                                const roundTrip = data?.filter(
                                  (other) => other.flights.length === 2
                                );
                                setAllFlight(roundTrip);
                              }
                            }}
                            checked={twoStop}
                            type="checkbox"
                            name=""
                            id=""
                          />{" "}
                          2 Stop
                        </div>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="w-full md:w-[75%] gap-5 flex flex-col  ">
                <div className=" ">
                  <div className="flex bg-red00 items-center justify-between  ">
                    <p className=" font-semibold text-[16px] ">
                      Available Flights
                    </p>

                    <div className="flex flex-col  gap- ">
                      <div className=" flex items-center text-red-500 gap-1  text-[20px]   ">
                        <BsClockHistory className=" " />
                        <span className=" text-red-500 md:text-primary font-semibold   ">
                          {minutes}
                        </span>
                        <span className=" text-2xl">:</span>
                        <span className=" text-red-500 md:text-primary font-semibold  ">
                          {seconds}
                        </span>
                      </div>
                      <p className=" text-sm ">until price update</p>
                    </div>
                  </div>

                  <div className="flex  flex-col  gap-2 w-full text-sm ">
                    <div className=" flex gap-4  items-center ">
                      {findLocationFromIATA(query.departure_id)}{" "}
                      <FaArrowRightLong />{" "}
                      {findLocationFromIATA(query.arrival_id)} .{" "}
                      {dateFormatter(query.outbound_date)}
                    </div>
                    {/* {flight?.flights[0].travel_class} */}
                  </div>
                </div>

                {!loading &&
                  allFlight &&
                  allFlight?.length !== 0 &&
                  allFlight?.map((flight) => (
                    <div
                      key={
                        flight?.booking_token
                          ? flight?.booking_token
                          : flight?.departure_token
                      }
                      onClick={() =>
                        setLinkIndex(
                          flight?.booking_token
                            ? flight?.booking_token
                            : flight?.departure_token
                        )
                      }
                      className="  w-full shadow-2xl rounded-lg flex flex-col gap-5  bg-white  border-[1px] p-5 "
                    >
                      <div
                        onClick={() => setOpen(!open)}
                        className=" w-full cursor-pointer border-fade rounded-lg border-[1px] flex flex-col gap-6  text-sm  "
                      >
                        <div
                          className={`px-5 border-b-[1px] pb-6 border-fade rounded-t-lg ${
                            open && flight?.booking_token
                              ? flight?.booking_token
                              : flight?.departure_token === listindex
                              ? "bg-[#EFF6FF]"
                              : ""
                          } py-5  `}
                        >
                          <div className=" flex flex-col gap-3 md:flex-row justify-between items-center  ">
                            <div className=" flex gap-3 w-full md:w-fit   ">
                              <div className="">
                                <div className=" rounded-full flex px-3 py-3 bg-form  ">
                                  <img
                                    src={flight?.flights[0].airline_logo}
                                    alt=""
                                    width={30}
                                  />
                                </div>
                              </div>
                              <div className="">
                                {/* <p className="blur-sm opacity-75"> */}
                                <p className="">{flight?.flights[0].airline}</p>
                                <p className="">
                                  {" "}
                                  {flight?.flights[0].flight_number} -{" "}
                                  {flight?.flights[0].travel_class}
                                </p>
                                <div className=" flex items-center gap-1 ">
                                  {/* <BsStarFill fill="#FACC13" /> 4.5{" "} */}
                                  {flight?.flights?.length} Stop(s)
                                </div>
                              </div>
                            </div>
                            <div className="flex gap-4 w-full md:w-fit items-center md:items-start justify-between md:justify-normal    ">
                              <div className=" flex flex-col gap-1 ">
                                <p className=" font-bold  ">
                                  ₦{numberFormatter(flight?.price * 10)}
                                </p>
                                <p className="text-sm capitalize ">
                                  total for 1 passenger
                                </p>
                              </div>
                              <div className=" px-6 py-1 rounded-full text-black/60 bg-green-500/80 text-sm h-fit ">
                                {flight?.type}
                              </div>
                            </div>
                          </div>
                          {flight?.flights?.length === 1 && (
                            <div className=" flex gap-2 mt-5 text-[12px] md:text-[15px] md:pt-0 items-center ">
                              <div className="  ">
                                <p className=" text-nowrap text-[13px] ">
                                  {dateFormatter(
                                    flight?.flights[0].departure_airport?.time
                                  )}
                                  ({" "}
                                  {dateTime(
                                    flight?.flights[0].departure_airport?.time
                                  )}
                                  )
                                </p>
                                <p className=" text-[13px] text-center ">
                                  {findLocationFromIATA(query.departure_id)}
                                </p>
                              </div>
                              <div className="border-b-[1px] border-faded/75 w-[50%] "></div>
                              <div className=" text-nowrap ">
                                {convertMinutesToHoursAndMinutes(
                                  flight?.total_duration
                                )}
                              </div>
                              <div className="border-b-[1px] border-faded/75 w-[50%] "></div>
                              <div className="  ">
                                <p className=" text-nowrap text-[13px] ">
                                  {dateFormatter(
                                    flight?.flights[0].arrival_airport?.time
                                  )}
                                  ({" "}
                                  {dateTime(
                                    flight?.flights[0].arrival_airport?.time
                                  )}
                                  )
                                </p>
                                <p className=" text-[13px] text-center ">
                                  {findLocationFromIATA(query.arrival_id)}
                                </p>
                              </div>
                            </div>
                          )}

                          {flight?.flights?.length === 2 && (
                            <div className="flex w-full items-center gap-2 ">
                              <div className=" w-full flex gap-2 pt-3 mt-3 text-[12px] md:text-[15px] md:pt-0 items-center ">
                                <div className="  ">
                                  <p className=" text-nowrap text-[13px] ">
                                    {dateFormatter(
                                      flight?.flights[0].departure_airport?.time
                                    )}
                                    ({" "}
                                    {dateTime(
                                      flight?.flights[0].departure_airport?.time
                                    )}
                                    )
                                  </p>
                                  <p className=" text-[13px] text-center ">
                                    {findLocationFromIATA(
                                      flight?.flights[0].departure_airport?.id
                                    )}
                                  </p>
                                </div>
                                <div className="border-b-[1px] border-faded/75 w-[50%] "></div>
                                <div className=" text-nowrap ">
                                  {convertMinutesToHoursAndMinutes(
                                    flight?.flights[0].duration
                                  )}
                                </div>
                                <div className="border-b-[1px] border-faded/75 w-[50%] "></div>
                                <div className=" text-[13px] text-nowrap ">
                                  <p className="text-center">
                                    {dateTime(
                                      flight?.flights[0]?.arrival_airport?.time
                                    )}
                                  </p>
                                  <p className="">
                                    {findLocationFromIATA(
                                      flight.flights[0]?.arrival_airport?.id
                                    )}
                                  </p>
                                </div>
                              </div>
                              <div className=" ">-</div>
                              <div className=" w-full flex gap-2 pt-3 text-[12px] md:text-[15px] md:pt-0 items-center ">
                                <div className="  ">
                                  <p className=" text-nowrap text-[13px] ">
                                    {dateFormatter(
                                      flight?.flights[1].departure_airport?.time
                                    )}
                                    ({" "}
                                    {dateTime(
                                      flight?.flights[1].departure_airport?.time
                                    )}
                                    )
                                  </p>
                                  <p className=" text-[13px] text-center ">
                                    {findLocationFromIATA(
                                      flight?.flights[1].departure_airport?.id
                                    )}
                                  </p>
                                </div>
                                <div className="border-b-[1px] border-faded/75 w-[50%] "></div>
                                <div className=" text-nowrap ">
                                  {convertMinutesToHoursAndMinutes(
                                    flight?.flights[1]?.duration
                                  )}
                                </div>
                                <div className="border-b-[1px] border-faded/75 w-[50%] "></div>
                                <div className=" text-nowrap text-center text-[13px]  ">
                                  <p className="">
                                    {dateTime(
                                      flight?.flights[1]?.arrival_airport?.time
                                    )}
                                  </p>
                                  <p className="">
                                    {findLocationFromIATA(
                                      flight.flights[1]?.arrival_airport?.id
                                    )}
                                  </p>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>

                        {open &&
                          (flight?.booking_token ||
                            flight?.departure_token === listindex) && (
                            <div className="px-5 flex flex-col gap-4 pb-5 ">
                              <div className=" w-full justify-between gap-2  flex my-3 flex-wrap  ">
                                <div className="flex items-center gap-3 ">
                                  <BsBag />
                                  <p className="">
                                    {flight?.flights[0].extensions[0]}
                                  </p>
                                </div>
                                <div className="flex items-center gap-3 ">
                                  <FaCoffee />
                                  <p className="">
                                    Aircraft: {flight?.flights[0].airplane}
                                  </p>
                                </div>
                                <div className="flex items-center gap-3 ">
                                  <BsWifi />
                                  <p className="">Amenities: Wi-Fi, Meals</p>
                                </div>
                              </div>

                              <div className="flex flex-col md:flex-row gap-4 ">
                                <Button
                                  onClick={() => {
                                    router(
                                      `${routeObj.booking}${
                                        flight?.booking_token
                                          ? flight?.booking_token
                                          : flight?.departure_token
                                      }`
                                    );
                                  }}
                                  className=" w-full py-3 bg-secondary text-white  "
                                >
                                  Book For Me
                                </Button>
                                <Button className=" w-full py-3 border-black border-[1px] text-  ">
                                  Book By Myself
                                </Button>
                              </div>
                            </div>
                          )}
                      </div>
                    </div>
                  ))}
              </div>
            </>
          )}

          {loading && (
            <>
              <div className=" w-full md:w-[25%]">
                {loading && (
                  <div className=" w-full shadow-2xl rounded-lg flex flex-col gap-5  bg-white  border-[1px] p-5 ">
                    <div className="flex py-3 animate-pulse bg-main/70 rounded-lg   items-center gap-2 w-full "></div>
                    <div className=" bg-main/70 animate-pulse  w-full flex justify-between rounded-md p-5 "></div>
                  </div>
                )}
              </div>

              <div className="w-full md:w-[75%] gap-5 flex flex-col  ">
                {loading && (
                  <div className=" flex flex-col gap-5 ">
                    <div className="flex bg-red00 items-center justify-between  ">
                      <p className=" bg-main/60 w-[60%] py-2 rounded-lg font-semibold text-[16px] "></p>

                      <div className="flex flex-col  gap- ">
                        <div className=" bg-main/60 w-[35%] py-2 animate-pulse rounded-lg flex items-center text-red-500 gap-1  text-[20px]   "></div>
                        <p className=" text-sm bg-main/60 w-[15%] py-2 animate-pulse rounded-lg  "></p>
                      </div>
                    </div>
                    <div className="  w-full shadow-2xl rounded-lg flex flex-col gap-5  bg-white  border-[1px] p-5 ">
                      <div className="flex  flex-col  gap-2 w-full text-sm ">
                        <p className=" font-semibold bg-main/70 animate-pulse py-3 w-[30%] rounded-md text-[16px] "></p>
                        <div className=" flex gap-4  items-center ">
                          <div className=" bg-main/70 animate-pulse py-2 rounded-md w-[5%] "></div>
                          <FaArrowRightLong />
                          <div className=" bg-main/70 animate-pulse py-2 rounded-md w-[25%] "></div>
                        </div>
                        <div className=" bg-main/70 animate-pulse py-2 rounded-md w-[50%] md:w-[5%] "></div>
                      </div>
                      <div className=" w-full bg-main/70 animate-pulse py-20 cursor-pointer border-fade rounded-lg border-[1px] flex flex-col gap-6  text-sm  "></div>
                    </div>{" "}
                    <div className="  w-full shadow-2xl rounded-lg flex flex-col gap-5  bg-white  border-[1px] p-5 ">
                      <div className="flex  flex-col  gap-2 w-full text-sm ">
                        <p className=" font-semibold bg-main/70 animate-pulse py-3 w-[30%] rounded-md text-[16px] "></p>
                        <div className=" flex gap-4  items-center ">
                          <div className=" bg-main/70 animate-pulse py-2 rounded-md w-[5%] "></div>
                          <FaArrowRightLong />
                          <div className=" bg-main/70 animate-pulse py-2 rounded-md w-[25%] "></div>
                        </div>
                        <div className=" bg-main/70 animate-pulse py-2 rounded-md w-[5%] "></div>
                      </div>
                      <div className=" w-full bg-main/70 animate-pulse py-20 cursor-pointer border-fade rounded-lg border-[1px] flex flex-col gap-6  text-sm  "></div>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}

          {!loading && allFlight?.length === 0 && (
            <EmptyList description="No available flight found" />
          )}
        </div>
      }
    </StaticLayout>
  );
}
